import React, { useEffect, useState, useContext } from "react";
import { useParams } from "react-router-dom";
import DesktopViewContext from "../context/DesktopViewContext";
import UserContext from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import ThankYou from "./ThankYou";
const JobApply = () => {
  const navigate = useNavigate();
  const {jobId} = useParams();
  const [isLoading, setIsLoading] = useState(true);
  const [showThankYou, setShowThankYou] = useState(false);
  const [job, setJob] = useState(null);
  const { desktopView } = useContext(DesktopViewContext);
  const { user } = useContext(UserContext);
  const api_endpoint = process.env.REACT_APP_API_ENDPOINT;
  const [formData, setFormData] = useState({ name: user ? user.name : '', email: user ? user.email : '', mobile: '' });
  const navigateToHome = () => {
    navigate("/");
  }
  useEffect(() => {
    const fetchJobDetail = async () => {
      try {
        const response = await fetch(api_endpoint + `/api/jobs/${jobId}`);
        const data = await response.json();

        setJob(data);
        setIsLoading(false);
      } catch (error) {
        setIsLoading(false);
      }
    };

    if (jobId) {
      fetchJobDetail();
    }
  }, [jobId]);
  const applyToJob = async () => {
    // Check if form fields are filled
    if (!formData.name || !formData.email) {
      alert("Kérjük töltse ki a mindkét mezőt!");
      return; // Exit the function if fields are empty
    }
    if (!formData.email.includes('@')) {
      alert("Érvényes email címet adjon meg!");
      return; // Exit the function if fields are empty
    }
    try {
      const response = await fetch(
        api_endpoint + "/api/jobs/" + jobId + "/applications",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            name: formData.name,
            email: formData.email,
            mobile: formData.mobile,
            jobId: jobId,
          }),
        }
      );

      if (!response.ok) {
        console.log(response);
        alert("Sikertelen jelentkezés " + response.message);
      }

      const data = await response.json();
      
      setShowThankYou(true);
      setTimeout(() => {
        navigateToHome();
      }, 6000);
    } catch (error) {
      alert("Sikertelen jelentkezés " + error.message);
    }
  };
  const handleNameOrEmailChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }
  if (showThankYou) {
    return (<ThankYou/>)
  }
  return (
    <div className="job-apply-container">
      <div className="inner-scroll-container">
      <h3>Jelentkezés az állásra.</h3>
      <div>
          <img
            src={job.logo}
            alt={`${job.company} logo`}
            width='180'
          />
            <h3 className="skill-group-h3">{job.name}</h3>
        <div className="job-description">
          <p>{job.description || "No description provided."}</p>
        </div>
        <p className="skill-group-h3">Töltse ki a formot majd véglegesítse jelentkezését!</p>

        <input
              className="input-field"
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleNameOrEmailChange}
              required
              autoFocus
              placeholder="Teljes név"
            />
            <input
              className="input-field"
              type="text"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleNameOrEmailChange}
              required
              placeholder="E-mail cím"
            />
            <input
              className="input-field"
              type="text"
              id="mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleNameOrEmailChange}
              required
              placeholder="Telefonszám"
            />
            <br></br>  <br></br> <br></br>
                  </div>
            <div className={desktopView ? "footer-desktop" : "footer"}>
              <button
                className="back-button"
                onClick={navigateToHome}
              >
                Vissza a főoldalra
              </button>
              <button className="apply-button" onClick={applyToJob}>
                Véglegesítés
              </button>
            </div>
      </div>

    </div>
  );
};

export default JobApply;
